export const HEADER_NAV_HEIGHT = 48; // 3rem